// extracted by mini-css-extract-plugin
module.exports = {"disabled":"TimeWidget_disabled__265cN"};